import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';



/*const ProtectedRoute = ({ children }) => {
  const { user, checkingAuth } = useAuth();

  useEffect(() => {
    console.log(user)
    if (!user && !checkingAuth) {
      // Build login URL with username if available
      const baseLoginUrl = '/api/auth/login';

      window.location.href = baseLoginUrl;
    }
  }, [user, checkingAuth]);

  if (checkingAuth || !user) return <div>Loading...</div>;

  return children;
};

export default ProtectedRoute;*/


const ProtectedRoute = ({ children }) => {
  const { user, checkingAuth } = useAuth();

  useEffect(() => {
    console.log(user);
    if (!user && !checkingAuth) {
      window.location.href = '/api/auth/login';
    }
  }, [user, checkingAuth]);

  if (checkingAuth || !user) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent"></div>
          <p className="text-blue-600 font-semibold text-lg">Authenticating...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;

